const emptyObject = Object.freeze({});
const emptyMap = Object.freeze(new Map());
const emptySet = Object.freeze(new Set());
const emptyString = "";
const emptyArray: readonly unknown[] = Object.freeze([]);

const emptyArrayOf = <T>() => emptyArray as T[];
const emptyObjectOf = <T>() => emptyObject as T;
const emptyMapOf = <Key, Value>() => emptyMap as Map<Key, Value>;
const emptySetOf = <Value>() => emptySet as Set<Value>;
export {
    emptyObject,
    emptyObjectOf,
    emptyArray,
    emptyArrayOf,
    emptyMap,
    emptyMapOf,
    emptySet,
    emptySetOf,
    emptyString,
};
